import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { H1,H6, Large } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import { Tab, Tabs } from '@dbk/ui-tabs';
import { NavigationList, NavigationListItem, NavigationListItemHeader, NavigationListItemFooter } from '@dbk/ui-list';
import { LoadingCircle } from '../../../src/components/common/loading';
import format from 'date-fns/format';
import { FormGroup, Label, Radio } from '@dbk/ui-forms';
import TableRow from '../../../src/components/common/table-row';
import SortingHeader from '../../../src/components/common/sorting-header';
import { formatDate } from './utils';
import ScrollableLayout from '../../../src/components/common/scrollable-layout';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import 'moment/min/locales';
import moment from 'moment';
import InverseProvider from '@dbk/ui-inverse';
import CalendarModal from '../../../src/components/common/calendar-modal';
import SimpleDate from '../../../src/components/common/date';
import BlurModal from '../../../src/components/common/blur-modal';
import DataExtractPortfolio from './data-export-portfolio';
// import ReportPortfolio from '../../../../dbk-web/@extension/CH/src/components/app/report-portfolio/report-portfolio';
import { DATA_EXPORT_TYPE } from '../../constants';
import { FormattedMessage } from '@dbk-legacy/format';
import Spinner from '@dbk/ui-spinner';
import { ReportTypes } from '../../../@extension/CH/src/screens/reports/constants';
import { PALETTE, EBANKINGWEBLUX, RM_REGION } from '../../constants';
import ExcelJS from 'exceljs/dist/exceljs';
import envConfig from '../../../db-env-build';
import {isDatePickerOpen} from './utils';

class DataExports extends PureComponent {


  constructor(props) {
    super(props);
    const { hideDWOPortfolioSelector } = this.props;
    hideDWOPortfolioSelector(true);
    this.callDirectExcelService = this.callDirectExcelService.bind(this);
    const currentDate = moment();
    const firstDayOfYear = moment().startOf('year').toDate();
    var asOfDate = moment(this.props.portfolio.overallMarketValue.asOfDate, 'YYYY-MM-DD').format('DD-MM-YYYY'); // WMCE-5129
    
    //  var asOfDate = moment("2020-10-20", 'YYYY-MM-DD').format('DD-MM-YYYY'); // WMCE-5129 for testing use latest As of Date(or T-1 date)

    const range = this.props.reports.selectedReportDetailsDateRange === 2;
    this.state = {
      downloadType: '',
      currentTab: 0,
      selectedDownloadFormatForTransactions: DATA_EXPORT_TYPE.CSV_FOR_TRANSACTIONS,
      selectedDownloadFormatForPositions: DATA_EXPORT_TYPE.CSV_FOR_POSITIONS,
      selectedDownloadAction: '',
      isDateRangeSelected: range,
      value: {
        from: firstDayOfYear,
        to: moment(asOfDate, "DD-MM-YYYY").toDate()
      },
      positionValue: moment(asOfDate, "DD-MM-YYYY").toDate(),
     }
  }

  componentDidUpdate(prevProps) {

    if(this.props.dataExports.initiateDataExtractResponse != prevProps.dataExports.initiateDataExtractResponse && 
      this.props.dataExports.initiateDataExtractResponse){
     const asOfDate = moment(this.props.portfolio.overallMarketValue.asOfDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
    //  var asOfDate = moment("2020-10-20", 'YYYY-MM-DD').format('DD-MM-YYYY');
      this.setState({
        value: {
          from: moment().startOf('year').toDate(),
          to: moment(asOfDate, "DD-MM-YYYY").toDate()
        },
      })
      if(document.querySelector('.modal__header-container')){
        document.querySelector('.modal__header-container').focus();
      }
    }

    if (this.props.reports.closeDatePicker === true
       && isDatePickerOpen(this.datepickerRef)) {
      this.onCancel();
    }
    if(document.querySelector('.modal-error-msg')){ // For forgot password popup focus
      document.querySelector('.modal-error-msg').focus();
    }
    if(this.state.value.from && this.state.value.to){
      setTimeout(() => {
        if(document.querySelector('#applybtnFocus')){
            document.querySelector('#applybtnFocus').focus();
          }
      }, 100);
    }
  }
  componentDidMount(){
    document.addEventListener(
      'click',
      this.handleClickOutside
    );

    this.props.dataExports.getInitiateDataExtract();
    const { dataExports : { initialDataExtractCall , setInitialDataExtractCall }} = this.props;
    if (initialDataExtractCall === true) {
      // resetStatmentsVariables();
      // this.fetchList();
      setInitialDataExtractCall(false);
    }
    if(document.querySelector('.logo-web')){
      document.querySelector('.logo-web').focus();
    }
  }

  // function: to fetch the list
  fetchList = () => {
    // Fetch Report Type ( CustomReports / Statements(edocuments),

    this.props.getPortfolioSelectorData();

    // const { reports: { selectedReportType } } = this.props;
    // if (selectedReportType === ReportTypes.STATEMENTS) {
    //   // Reset all variables and then fetch list accordingly
    //   // Default values:: Category-Unread, range- 7days,
    //   this.props.getDocuments();
    // }
  }

  onApplyDateChange = () => {
    this.onCancel();
    this.props.dataExports.setInitiateDataExtractResult(false);
    // TODO 
    // this.props.fetchDocumentsForCategories(this.state.value.from.format('YYYY-MM-DD'),
    //   this.state.value.to.format('YYYY-MM-DD'));
  }

  onCancel = () => {
    this.datepickerRef.close();
    this.datepickerRef1.close();
    this.props.setDatePickerClose(false);
  }

  customFooter = (txType) => {
    const { i18n: { messages } } = this.props;

    // if(!this.props.dataExports.distinctDates && (this.datepickerRef.datepicker.state.isOpen || this.datepickerRef1.datepicker.state.isOpen)){
    //   this.props.dataExports.getDistinctDatesForCalendar(txType);
    // }
    
    // if(this.props.dataExports.distinctDates){
        return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" }} >
        <div className='datepicker-footer-txt' tabIndex={0}>
          <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
        </div>
        <div className='datepicker-footer-btn'>
          <Button tertiary
            onClick={() => this.onCancel()}
          >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

          <Button
            id="applybtnFocus"
            disabled={!(this.state.value.from && this.state.value.to)}
            onClick={() => this.onApplyDateChange()}
          >{messages['app.common.select']}</Button>
        </div>
      </InverseProvider>
    // }

    // return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" }} >
    //       <div style={{  display: "flex", 'justify-content' : 'center'}}>
    //         <div>
    //           {messages["app.dataExports.fetch.data"]}
    //         </div>
    //         <Spinner/>
    //       </div>
    //     </InverseProvider>
    
  }

  customFooterPositions = (txType) => {
    const { i18n: { messages } } = this.props;

    if(!this.props.dataExports.distinctDates && isDatePickerOpen(this.datepickerRef)){
      this.props.dataExports.getDistinctDatesForCalendar(txType);
    }
    
    if(this.props.dataExports.distinctDates){
        return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61",  width: "100%", height: "50px", backgroundColor: '#12213c', padding: "10px" }} >
        <div style={{ width: "100%", display: "inline-grid", float: 'left' }}>
          <Text style={{ padding: "2px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
        </div>
      </InverseProvider>
    }

    return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" }} >
          <div style={{  display: "flex", 'justify-content' : 'center'}}>
            <div>
              {messages["app.dataExports.fetch.data"]}
            </div>
            <Spinner/>
          </div>
        </InverseProvider>
    
  }


  onRadioSelectedForTransactions = (selectedDownloadFormatForTransactions) => {
    this.setState({
      selectedDownloadFormatForTransactions
    })
  }

  onRadioSelectedForPositions = (selectedDownloadFormatForPositions) => {
    this.setState({
      selectedDownloadFormatForPositions
    })
  }

  onDocumentDownload = (parameter, dateRange) => {
    this.setState({
      selectedDownloadAction: parameter, downloadType: parameter
    })

    var selectedFromDate;
    var selectedToDate

    var fileType;

    if(parameter === DATA_EXPORT_TYPE.TRANSACTIONS){
        selectedFromDate = moment(dateRange.from).format("YYYY-MM-DD");
        selectedToDate = moment(dateRange.to).format("YYYY-MM-DD");
        fileType = this.state.selectedDownloadFormatForTransactions === DATA_EXPORT_TYPE.XLX_FOR_TRANSACTIONS ? DATA_EXPORT_TYPE.XLS : DATA_EXPORT_TYPE.CSV;
    }
    if(parameter === DATA_EXPORT_TYPE.POSITIONS){
      selectedFromDate = "";
      selectedToDate = moment(dateRange).format("YYYY-MM-DD");
      fileType = this.state.selectedDownloadFormatForPositions === DATA_EXPORT_TYPE.XLX_FOR_POSITIONS ? DATA_EXPORT_TYPE.XLS : DATA_EXPORT_TYPE.CSV;
  }
    this.props.dataExports.getExtractVolume(parameter, selectedFromDate, selectedToDate, fileType);
  }

  transactionHistoryDownloads(dateRange) {
    const { i18n: { messages },
      dataExports: { loading}, 
      auth: { documentDownloadDisabled } } = this.props;

    return (
      <div className='btn-change-reports-container' align='right' style={{ marginTop: "30px" }}>
        <Button
          testID="btn_transaction_history_downloads_test"
          size='large'
          disabled={documentDownloadDisabled}
          tertiary={documentDownloadDisabled}
          loading={loading && this.state.selectedDownloadAction === DATA_EXPORT_TYPE.TRANSACTIONS}
          onClick={() => this.onDocumentDownload(DATA_EXPORT_TYPE.TRANSACTIONS, dateRange)}
        >{messages['app.downloads.download']}
        </Button>
      </div>
    );
  }

  positionDownloads(dateRange, fileType) {
    const { i18n: { messages },
      dataExports: { loading}, 
      auth: { documentDownloadDisabled } } = this.props;

    return (
      <div className='btn-change-reports-container' align='right' style={{ marginTop: "30px" }}>
        <Button
          testID="btn_positionReport_reportPositionsDownloads_test"
          size='large'
          disabled={documentDownloadDisabled}
          tertiary={documentDownloadDisabled}
          loading={loading && this.state.selectedDownloadAction === DATA_EXPORT_TYPE.POSITIONS}
          onClick={() => this.onDocumentDownload(DATA_EXPORT_TYPE.POSITIONS, dateRange)}
        >{messages['app.downloads.download']}
        </Button>
      </div>
    );
  }

  JSONToCSV(JSONData, ReportTitle) {
    const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
    let CSV = '';
    var row = '';
    for (const index1 in arrData.sections) {
      
      for (var index in arrData.sections[index1].headers) {
        row += arrData.sections[index1].headers[index] + ',';
      }
      row = row.slice(0, -1);
      CSV += row + '\r\n';
      for (let i = 0; i < arrData.sections[index1].results.length; i++) {
        var row = '';
        for (var index in arrData.sections[index1].results[i]) {
          row += '"' + arrData.sections[index1].results[i][index] + '",';
        }
        row.slice(0, row.length - 1);
        CSV += row + '\r\n';
      }
    }
    if (CSV === '') {
      alert('Invalid data');
      return;
    }
    // if (ReportTitle === 'Positions') {
    //   ReportTitle = 'Portfolios';
    // }
    let fileName = '';
    fileName += ReportTitle.replace(/ /g, '_');

    const uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
    const anchor = document.createElement('a');
    anchor.href = uri;

    anchor.style = 'visibility:hidden';
    //anchor.download = fileName + '.csv';
    anchor.download = JSONData.sheetname;   //WMCE-47133-For updating file format of csv file

    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  createXmlHeader(arrData) {
    let headerRow = '<ss:Row>\n';
    // let dataRow = '';

    for (const preRow in arrData.sections) {
    
      for (const index in arrData.sections[preRow].headers) {
        headerRow += '  <ss:Cell ss:StyleID="xls-style-1">\n';
        headerRow += '    <ss:Data ss:Type="String">';
        headerRow += arrData.sections[preRow].headers[index] + '</ss:Data>\n';
        headerRow += '  </ss:Cell >\n';
      }
    }

    headerRow += '</ss:Row>\n';
    return (
      '<?xml version="1.0"?>\n' +
      '<ss:Workbook xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">\n' +
      '<ss:Styles>\n' +
      '<ss:Style ss:ID="xls-style-1" ss:Name="xls-style-1">\n' +
      '<ss:Alignment ss:Vertical="Bottom" ss:Horizontal="Left"/>\n' +
      '<ss:Borders>\n' +
      '<ss:Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '<ss:Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#DDDDDD"/>\n' +
      '</ss:Borders>\n' +
      '<ss:Font ss:Color="#545454" ss:Bold="1" />\n' +
      '<ss:Interior ss:Color="#FFFFFF" ss:Pattern="Solid"/>\n' +
      '</ss:Style>\n' +
      '</ss:Styles>\n' +
      '<ss:Worksheet ss:Name="Sheet1">\n' +
      '<ss:Table>\n' +
      '<ss:Row/>\n' +
      headerRow
    );
  }

  createXmlFooter() {
    return '</ss:Table>\n' + '</ss:Worksheet>\n' + '</ss:Workbook>\n';
  }

  jsonToXml(jsonObject) {
    let row;
    var col;
    let xml;
    const arrData =
      typeof jsonObject !== 'object' ? JSON.parse(jsonObject) : jsonObject;

    xml = this.createXmlHeader(arrData);

    for (const rowData in arrData.sections) {
      for (
        let resultsLength = 0;
        resultsLength < arrData.sections[rowData].results.length;
        resultsLength++
      ) {
        xml += '<ss:Row>\n';
        for (var col in arrData.sections[rowData].results[resultsLength]) {
          xml += '  <ss:Cell>\n';
          xml += '    <ss:Data ss:Type="String">';
          xml +=
            arrData.sections[rowData].results[resultsLength][col] +
            '</ss:Data>\n';
          xml += '  </ss:Cell>\n';
        }
        xml += '</ss:Row>\n';
      }
    }
    xml += this.createXmlFooter();
    return xml;
  }
  getHeaders(data){
    return data.map((elem, index) => (
      {
        header: elem,
        key: index
      } 
    ));
  }

  async saveAsExcel(data, filename) {

    const arrData = typeof data !== 'object' ? JSON.parse(data) : data;

    const fileName = filename.replace(/\.[^/.]+$/, ".xlsx")
    
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet()

    //1. create the columns
    worksheet.columns = data.sections[0].headers ? this.getHeaders(data.sections[0].headers): [''];

    //2. add rows with values
    for (const index in arrData.sections[0].results) {
      worksheet.addRow(arrData.sections[0].results[index]);
    }
    //3. add bold text style to column
    worksheet.getRow(1).font = { bold: true }

    //4. write the data buffer
    const buf = await workbook.xlsx.writeBuffer()

    //5. download the data in xlsx format
    const anchor = document.createElement('a');
    const blob = new Blob([buf]);

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      anchor.href = (window.URL || window.webkitURL).createObjectURL(blob);
      anchor.download = fileName;
    }
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}

  excelDownload(content, filename, contentType) {
    if (!contentType) contentType = 'application/octet-stream';
    const anchor = document.createElement('a');
    const blob = new Blob([content], {
      type: contentType,
    });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      anchor.href = (window.URL || window.webkitURL).createObjectURL(blob);
      anchor.download = filename;
    }
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dataExports.custom.downloads.result !== nextProps.dataExports.custom.downloads.result) {
      const result = nextProps.dataExports.custom.downloads.result;
      const downloadSelected = this.state.selectedDownloadAction;
      let fileType = '';
      if(result && result.sections[0] && result.sections[0].headers && result.sections[0].results){
        if (downloadSelected === DATA_EXPORT_TYPE.TRANSACTIONS) {
          fileType = this.state.selectedDownloadFormatForTransactions
          if (this.state.selectedDownloadFormatForTransactions === DATA_EXPORT_TYPE.CSV_FOR_TRANSACTIONS) {
            // this.CSVDownload(
              this.JSONToCSV(result, downloadSelected);
          }
          else {
            this.saveAsExcel(
              result, 
              result.sheetname ? result.sheetname : this.state.downloadType + '.xlsx',
              );
          }
        }
        else {
          fileType = this.state.selectedDownloadFormatForPositions
          if (this.state.selectedDownloadFormatForPositions === DATA_EXPORT_TYPE.CSV_FOR_POSITIONS) {
            // this.CSVDownload(
              this.JSONToCSV(result, downloadSelected);
              // result.sheetname ? result.sheetname : this.state.downloadType + '.csv',
              // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            // );
          }
          else {
            this.saveAsExcel(
              result, 
              result.sheetname ? result.sheetname : this.state.downloadType + '.xlsx',
              );
          }
        }
      }
    }
  }

  callDirectExcelService(trxType) {
   
    const {
      settings: { currentEnvironment: { remoteUrl } },
      reports: { custom: { extract: { downloads: { startDate, endDate } } } },
      selectedPortfolioData,
      i18n: { messages },
    } = this.props;
    this.setState({ downloadType: trxType });
    this.props
      .downLoadReport({
        reportname: trxType,
        fromDate: startDate,
        toDate: endDate,
      })
      .then((success) => {
       
      }).catch((error) => {
        
      });;
  }

  
  onChangeRange = (range) => {
    this.setState({
      value: {
        ...range
      }
    });
  }

  onChangePositionRange = (range) =>{
  
    this.setState({positionValue: moment(range, "DD-MM-YYYY").toDate()});
  }

  hideGenericErrorModal = () => {
    this.props.dataExports.setBlurModalError(false);
  }

  showGenericErrorModal = () => {
    const { i18n: { messages }, dataExports : { errorMessage, errorTitle } } = this.props;
    return (
      <View >
        <BlurModal
          visible={this.props.dataExports.blurModalError}
          doneVisible={false}
          backVisible={false}
          testID="blur_modal_test"
          accessibilityLabel="blur_modal_test"
          title={<div size="large">{errorTitle}</div>}
          onDone={() => this.hideGenericErrorModal()}
        >
          <div>
            <div className="modal-error-msg" tabIndex={0}>{errorMessage}</div>
            <div className="margin-top-20 margin-bottom-20 small-12 medium-push-4 medium-4 center">
              <Button
                fullWidth size='large'
                testID="button_ok_message_test"
                accessibilityLabel="button_ok_message_test"
                onPress={() => this.hideGenericErrorModal()} >
                {messages['app.rmAccess.button.ok']}
              </Button>
            </div>
          </div>
        </BlurModal>
      </View>
    )
  }

  handleClickOutside = () => {
    if(isDatePickerOpen(this.datepickerRef) === false && isDatePickerOpen(this.datepickerRef1) === false){
        this.props.dataExports.setDistinctDates(null);
      }
  }

  // Funtion to disable Friday and Saturday in calendar
  getDisabledFridaysAndSaturdays = (startDate, endDate) => {
    const days = [];
    let current = new Date(startDate);
    while (current <= endDate) {
      if (current.getDay() === 5 || current.getDay() === 6) {
        days.push(new Date(current));
      }
      current.setDate(current.getDate() + 1);
    }
    return days;
  }
  
  render() {
    const { profile, auth, i18n: { messages }, dataExports: { blurModalError } } = this.props;
    const { auth: { langCode, documentDownloadDisabled } } = this.props;
    const rowMarkerStyle = { fill: 'transparent' };
    const { reports: { showSpinner, startDate, endDate, selectedReportDetailsDateRange, totalDocs30Days, totalDocs7Days, totalDocsCustomRange } } = this.props;

    const receivedDate = formatDate(new Date(), langCode);

    const showDescription = this.props.dataExports && this.props.dataExports.initiateDataExtractResponse;
    var asOfDate = moment(this.props.portfolio.overallMarketValue.asOfDate, 'YYYY-MM-DD').format('DD-MM-YYYY'); // WMCE-5129
    //  var asOfDate = moment("2020-10-20", 'YYYY-MM-DD').format('DD-MM-YYYY');  // WMCE-5129 - for testing use latest AsofDate
    auth.resetInfoMessage();
    
    const transStartDate = this.props.dataExports.initiateDataExtractResponse ? moment(this.props.dataExports.initiateDataExtractResponse.minTranExportDate, "DD-MM-YYYY").toDate(): undefined;
    const transEndDate =  this.props.dataExports.initiateDataExtractResponse ? moment(asOfDate, "DD-MM-YYYY").toDate(): undefined;

    const minDate = this.props.dataExports.initiateDataExtractResponse
      ? moment(this.props.dataExports.initiateDataExtractResponse.minPosExportDate, "DD-MM-YYYY").toDate()
      : undefined;
    const maxDate = this.props.dataExports.initiateDataExtractResponse
      ? moment(asOfDate, "DD-MM-YYYY").toDate()
      : undefined;

    const disabledDays = (minDate && maxDate)
      ? this.getDisabledFridaysAndSaturdays(minDate, maxDate)
      : [];
    return (
    <div className="data-exports">
      {/* <div>
        <DataExtractPortfolio />
      </div> */}
      <div className="row large-collapse">
        <div className="profile-container">
          <div id="title_report_reportHome_test" className="profile-container__title" style={{ paddingLeft: 30 }}>
          <H1 className="data-title margin-top-1" tabIndex={0}>{messages['app.common.pageTitle.dataExports']}</H1>
            <Text size="big" tabIndex={0} className="data-sub-title" primary> {showDescription ? <FormattedMessage
                id={'app.dataExports.description'}
                values={{ TxHistoryDate: this.props.dataExports.initiateDataExtractResponse.minTranExportDate,
                  positionExtractDate: this.props.dataExports.initiateDataExtractResponse.minPosExportDate }}
                /> :  
              <div class="data-export-description-spinner"><Spinner /></div>}
            </Text>
            <div className="data-disclaimer">
            <Text size="large" tabIndex={0}>
              { envConfig.envConfig == EBANKINGWEBLUX || envConfig.rmRegion == RM_REGION ? messages['app.dataExports.disclaimerForLux'] : messages['app.dataExports.disclaimer'] }
            </Text>
            </div>

          </div>
          <ScrollableLayout style={{ padding: 0 }}
            body={
              <div className="row scrollBarHide" id="scrollBarHide" style={{ minHeight: '450px' }} >
                <div className="columns large-6" >
                  <NavigationListItem testID="list_positionReport_reportsPositionsDownloads_test" tabIndex={-1} role="presentation"
                    inverse selected='true' hasArrow={false} style={{ height: 150 }}
                  >
                    <View style={{ flexDirection: 'column', width: '100%' }}>
                      <View style={{ flexDirection: 'row', width: '100%' }}>
                        <View style={{
                          width: '50%', height: "90px",
                          flexDirection: "row", alignItems: 'center', justifyContent: 'flex-end', float: 'left'
                        }}>
                          <NavigationListItemHeader>
                            <H6 tabIndex={0}
                              className="rowHeader export-header"
                              >
                              {messages['app.dataExports.transactionHistory']}
                            </H6>
                          </NavigationListItemHeader>
                        </View>

                        <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', width: '50%', height: '90px' }}>
                          <Large>
                            {/* {receivedDate} */}
                            <View className="customReportCalendar" style={{
                              height: "90px", width: "100%",
                              flexDirection: "row", alignItems: 'center', justifyContent: 'flex-end', float: 'right'
                            }}>
                              <View style={{

                                margin: "20px 20px 15px 15px", width: '120%', float: 'right'
                              }}>
                                 { !this.props.logoutPopup.isVisible &&  <DatePicker
                                  ref={(ref) => this.datepickerRef1 = ref}
                                  showOutsideMonthDays={false}
                                  tetherProps={{attachment : "top center", targetAttachment : "right center"}}
                                  // disabled={!this.props.dataExports.initiateDataExtractResponse}
                                  enableYearNavigation
                                  className="input-container"
                                  enableRangeSelection
                                  onChange={this.onChangeRange}
                                  value={this.state.value}
                                  startDate={transStartDate}
                                  endDate={transEndDate}
                                  // enabledDays={this.props.dataExports.distinctDates}
                                  inputDateFormat={'dd MMM yyyy'}
                                  rangeSeparator={' - '}
                                  selectionStart={this.state.value.from}
                                  selectionEnd={this.state.value.to}
                                  disableWeekendDays
                                  renderFooter={() => this.customFooter(DATA_EXPORT_TYPE.TRANSACTIONS)}
                                  locale={this.props.auth.langCode}
                                  weekStartsOn={1} // Monday is the first day of the week.
                                />}
                              </View>

                            </View>
                          </Large>
                        </View>

                      </View>
                      <NavigationListItemFooter
                        secondary style={{ overflow: 'visible', width: "100%", paddingBottom: 30, paddingRight: 50 }}>
                        <Radio
                          title={`${messages['app.dataExports.radioButton.CSV']}`}
                          className="dataExportsRadioButton"
                          checked={this.state.selectedDownloadFormatForTransactions === DATA_EXPORT_TYPE.CSV_FOR_TRANSACTIONS}
                          onChange={() => this.onRadioSelectedForTransactions(DATA_EXPORT_TYPE.CSV_FOR_TRANSACTIONS)}
                        />
                        <div tabIndex={0}>
                          <Text numberOfLines={2}
                            className="rowHeader dataExportsRadioButton"
                            style={{ marginRight: 20 }}
                            testID="textbox_report_reportCategoryListHeader_test">
                            {messages['app.dataExports.radioButton.CSV']}
                          </Text>
                        </div>
                        <Radio
                          title={`${messages['app.dataExports.radioButton.XLS']}`}
                          className="dataExportsRadioButton"
                          checked={this.state.selectedDownloadFormatForTransactions === DATA_EXPORT_TYPE.XLX_FOR_TRANSACTIONS}
                          onChange={() => this.onRadioSelectedForTransactions(DATA_EXPORT_TYPE.XLX_FOR_TRANSACTIONS)}
                        />
                        <div tabIndex={0}>
                          <Text numberOfLines={2}
                            className="rowHeader dataExportsRadioButton"
                            style={{ marginRight: 20 }}
                            testID="textbox_report_reportCategoryListHeader_test">
                            {messages['app.dataExports.radioButton.XLS']}
                          </Text>
                        </div>
                      </NavigationListItemFooter>
                    </View>
                  </NavigationListItem>
                  <div>
                    {this.transactionHistoryDownloads(this.state.value)}
                  </div>

                </div>
                <div className="columns large-6" >
                  <NavigationListItem testID="list_positionReport_reportsPositionsDownloads_test" tabIndex={-1} role="presentation" 
                    inverse selected='true' hasArrow={false} style={{ height: 150 }}
                  >
                    <View style={{ flexDirection: 'column', width: '100%' }}>
                      <View style={{ flexDirection: 'row', width: '100%' }}>
                        <View style={{
                          width: '50%', height: "90px",
                          flexDirection: "row", alignItems: 'center', justifyContent: 'flex-end', float: 'left'
                        }}>
                          <NavigationListItemHeader>
                            <H6 tabIndex={0}
                              className="rowHeader export-header" >
                              {messages['app.dataExports.positionStatement']}
                            </H6>
                          </NavigationListItemHeader>
                        </View>
                        <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', width: '50%', height: '90px' }}>
                          <Large>
                            {/* {receivedDate} */}
                            <View className="customReportCalendar" style={{
                              height: "90px", width: "100%",
                              flexDirection: "row", alignItems: 'center', justifyContent: 'flex-end', float: 'right'
                            }}>
                              <View style={{
                                margin: "20px 20px 15px 15px", width: '100%', float: 'right'
                              }}>
                             { !this.props.logoutPopup.isVisible &&    <DatePicker
                                  ref={(ref) => this.datepickerRef = ref}
                                  type='portrait'
                                  tetherProps={{attachment : "left center", targetAttachment : "bottom center"}}
                                  className="input-container"
                                  disabled={!this.props.dataExports.initiateDataExtractResponse}
                                  showOutsideMonthDays={false}
                                  onChange={this.onChangePositionRange}
                                  value={this.state.positionValue}
                                  startDate={this.props.dataExports.initiateDataExtractResponse ? moment(this.props.dataExports.initiateDataExtractResponse.minPosExportDate, "DD-MM-YYYY").toDate(): undefined}
                                  endDate={this.props.dataExports.initiateDataExtractResponse ? moment(asOfDate, "DD-MM-YYYY").toDate(): undefined}
                                  enabledDays={this.props.dataExports.distinctDates}
                                  inputDateFormat={'dd MMM yyyy'}  
                                  renderFooter={() => this.customFooterPositions(DATA_EXPORT_TYPE.POSITIONS)}
                                  locale={this.props.auth.langCode}
                                  disabledDays={disabledDays}
                                  weekStartsOn={1} // Monday is the first day of the week.
                                />}                          
                              </View>
                            </View>
                          </Large>
                        </View>
                      </View>
                      <NavigationListItemFooter
                        secondary style={{ overflow: 'visible', width: "100%", paddingBottom: 30, paddingRight: 50 }}>

                        <Radio
                          title={`${messages['app.dataExports.radioButton.CSV']}`}
                          className="dataExportsRadioButton"
                          checked={this.state.selectedDownloadFormatForPositions === DATA_EXPORT_TYPE.CSV_FOR_POSITIONS}
                          onChange={() => this.onRadioSelectedForPositions(DATA_EXPORT_TYPE.CSV_FOR_POSITIONS)}
                        />
                        <div tabIndex={0}>
                          <Text numberOfLines={2}
                            className="rowHeader dataExportsRadioButton"
                            style={{ marginRight: 20 }}
                            testID="textbox_report_reportCategoryListHeader_test">
                            {messages['app.dataExports.radioButton.CSV']}
                          </Text>
                        </div>

                        <Radio
                          title={`${messages['app.dataExports.radioButton.XLS']}`}
                          className="dataExportsRadioButton"
                          checked={this.state.selectedDownloadFormatForPositions === DATA_EXPORT_TYPE.XLX_FOR_POSITIONS}
                          onChange={() => this.onRadioSelectedForPositions(DATA_EXPORT_TYPE.XLX_FOR_POSITIONS)}
                        />
                        <div tabIndex={0}>
                          <Text numberOfLines={2}
                            className="rowHeader dataExportsRadioButton"
                            style={{ marginRight: 20 }}
                            testID="textbox_report_reportCategoryListHeader_test">
                            {messages['app.dataExports.radioButton.XLS']}
                          </Text>
                        </div>

                      </NavigationListItemFooter>
                    </View>
                  </NavigationListItem>
                  <div>
                    {this.positionDownloads(this.state.positionValue)}
                  </div>
                </div>
              </div>
            }
          />
           {blurModalError && this.showGenericErrorModal()}
        </div>
      </div>
    </div>

    );
  }

  componentWillUnmount() {
    const { hideDWOPortfolioSelector, dataExports: { setInitialDataExtractCall, setDistinctDates }} = this.props;
    setInitialDataExtractCall(true);
    setDistinctDates(null);
    hideDWOPortfolioSelector(false);
    document.removeEventListener(
      'click',
      this.handleClickOutside
    );
  }
}

DataExports.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
  downloads: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    isDateBarClickable: PropTypes.bool,
  }),
  settings: PropTypes.shape({
    currentEnvironment: PropTypes.shape({
      remoteUrl: PropTypes.string,
    }),
  }),
  auth: PropTypes.shape({
    userId: PropTypes.string,
    authHeader: PropTypes.string,
    lastSession: PropTypes.string,
  }),
  app: PropTypes.shape({
    user: PropTypes.shape({
      selectedPortfolioData: PropTypes.string,
    }),
  }),
  rsa: PropTypes.shape({
    rsaAuthorised: PropTypes.bool,
  }),
};

export default createContainer(
  {
    $queries: {
      hideDWOPortfolioSelector: {
        $set: 'reports.hideDWOPortfolioSelector'
      },
      dataExports: {
        getInitiateDataExtract: { $call:  'initiateDataExtract'},
        initiateDataExtractResponse: true,
        loading: true,
        initialDataExtractCall: true,
        setInitialDataExtractCall: { $set : 'initialDataExtractCall'},
        initiateDataExtractResultValid: true,
        setInitiateDataExtractResult: { $set: 'initiateDataExtractResultValid'},
        getExtractVolume: { $call: 'getExtractVolume'},
        blurModalError: true,
        errorMessage: true,
        setBlurModalError: {  $set: 'blurModalError' },
        errorTitle: true,
        distinctDates: true,
        setDistinctDates: { $set: 'distinctDates'},
        getDistinctDatesForCalendar: { $call: 'getDistinctDates'},
        custom: {
          downloads: {
            result: true
          }
        },
      },
      portfolio:{
        overallMarketValue:{
          asOfDate: true
        }
      },
      getPortfolioSelectorData: { $call: 'dataExports.user.setDataExportsPortfoliosData'},
      changePage: { $call: 'ui.history.push' },
      i18n: {
        messages: true,
      },
      downloads: {
        calendar: {
          open: {
            $call: 'open',
          },
          ...CalendarModal.getFragment('calendarModal'),
        },
        startDate: true,
        endDate: true,
        isDateBarClickable: true,
        setFalse: { $set: 'isDateBarClickable' },
        setStartDateEmpty: { $set: 'startDate' },
        setEndDateEmpty: { $set: 'endDate' },
        downLoadReport: { $call: 'excelData' },
        result: true,
      },
      reports: {
        showSpinner: true,
        lastMonthStatements: true,
        totalDocs7Days: true,
        totalDocs30Days: true,
        totalDocsCustomRange: true,
        statement: {

        },
        selectedReportDetailsDateRange: true,
        calendar: {
          open: {
            $call: 'open'
          },
          ...CalendarModal.getFragment('calendarModal'),
        },
        startDate: true,
        endDate: true,
        closeDatePicker: true,
        custom: {
          extract: {
            downloads: {
              startDate: true,
              endDate: true
            }
          },
          downloads: {
            result: true
          }
        },
        trans: {
          calendar: {
            open: {
              $call: 'open'
            },
            ...CalendarModal.getFragment('calendarModal'),
          },
          startDate: true,
          endDate: true,
          dateDisplay: true,
          transactionHistoryList: true,
          isLoading: true,
        },
      },
      downLoadReport: { $call: 'reports.custom.downloads.excelData' },
      resetDownloadDates: { $call: 'downloads.resetDates' },
      clearDownloadDates: { $call: 'downloads.clearDates' },
      screen: {
        width: true,
        height: true,
        isSmall: true,
      },
      settings: {
        currentEnvironment: {
          remoteUrl: true,
        },
      },
      rsaChangePage: { $call: 'rsa.changePage' },
      auth: {
        userId: true,
        resetInfoMessage: { $call: 'resetInfoMessage' },
        lastSession: true,
        authHeader: true,
        langCode: true,
        documentDownloadDisabled: true,
      },
      app: {
        user: {
          selectedPortfolio: true,
        },
      },
      rsa: {
        rsaAuthorised: true,
        onChangePage: { $call: 'changePage' },
      },
      edelivery: {
        getUserPreferences: { $call: 'getUserPreferences' },
        showPrompt: true,
      },
      getLastStatements: {
        $call: 'reports.getLastStatements',
      },
      getDocuments: {
        $call: 'reports.getDocuments',
      },
      // setRangeYTD: {
      //     $call: 'reports.setRangeYTD'
      // },
      setDuration: {
        $call: 'reports.setDuration'
      },
      setReportDetailDateRange: {
        $call: 'reports.setReportDetailDateRange'
      },
      setDataForNotificationList: {
        $call: 'reports.setDataForNotificationList'
      },
      fetchDocumentsForCategories: {
        $call: 'reports.fetchDocumentsForCategories'
      },
      setStartDate: { $set: 'reports.startDate' },
      setEndDate: { $set: 'reports.endDate' },

      setDatePickerClose: {
        $set: 'reports.closeDatePicker'
      },
      setTransactionHistoryData: {
        $call: 'reports.trans.setTransactionDetails'
      },
      logoutPopup: {isVisible : true},
      user: {
        setSelectedPortfolioId: {
          $set: 'selectedPortfolioId',
        },
      },
    },
  },
  ({ app, ...queries }) => ({
    selectedPortfolioData: app.user.selectedPortfolioData,
    ...queries,
  })
)(DataExports);

export { DataExports };
